import React from 'react'
import './index.css';
import { Link } from 'react-router-dom';


function ButtonPink({ text, handleOnClick }) {
    
    return (

        <button className="lover-button-pink" onClick={handleOnClick}>
            <p>{text}</p>
        </button>
    )
}

export default ButtonPink;

